import React, { useContext, useEffect, useState } from 'react';
import Modal from '../../../UI/Modal/Modal'
import cl from './Add.module.css'
import Upload from "../../../../assets/Icon/Upload";
import MultiSelect from '../../../UI/Inputs/MultiSelect';
import { AppContext } from '../../../../providers/appProvider';
import { selectStyle } from './selectStyle';
import us_example from '../../../../assets/Docs/us_example.xlsx';
import kr_example from '../../../../assets/Docs/kr_example.xlsx';
import other_example from '../../../../assets/Docs/other_example.xlsx';
import { useTranslation } from 'react-i18next';
import Select from "react-select"; 
 
const AddTransportPriceModal = ({ transportPriceService, defaultPrice }) => {
    const {t} = useTranslation();
    const transportPriceResetData = {
        name: "",
        location_country_id: 0,
        website_id: 0,
        reciever_country_id: 0, 
        reciever_city_id: 0,
        reciever_city_id: 0,

    }
    const { appState, app } = useContext(AppContext);
    const websites = appState.websites.map((website) => ({ value: website.id, label: website.name })); 
    const countries = appState.countries.map((country) => ({ value: country.id, label: country.name })); 
    const [uploadedFile, setUploadedFile] = useState(null);

    const [newTransportPrice, newNewTransportPrice] = useState(transportPriceResetData)
    const [isFirstValidated, setIsFirstValidated] = useState(false)
    const [validates, setValidates] = useState({})

    const validatePrice = (transportPrice) => {
        const messages = {};

        if (transportPrice.location_country_id < 1) {
            messages.location_country_id = { message: 'სავალდებულოა', isValid: false };
        }

        if (transportPrice.website_id < 1) {
            messages.website_id = { message: 'სავალდებულოა', isValid: false };
        }

        if (transportPrice.reciever_country_id < 1) {
            messages.reciever_country_id = { message: 'სავალდებულოა', isValid: false };
        }

        if (transportPrice.reciever_city_id < 1) {
            messages.reciever_city_id = { message: 'სავალდებულოა', isValid: false };
        }

 

        const isValid = Object.keys(messages).length === 0;
        setValidates(messages)
        return isValid;
    };

    const reValidate = () => {
        const isValidate = validatePrice(newTransportPrice)

    }

    const handleFileChange = (event) => {
        const file = event.target.files[0];  
        setUploadedFile(file);               
    };

    useEffect(() => {
        if (isFirstValidated === true) {
            const isValidate = validatePrice(newTransportPrice)
        }
    }, [newTransportPrice, isFirstValidated]);

    const [isModalOpen, setIsModalOpen] = useState(false);

    const saveHandle = () => {

        const isValidate = validatePrice(newTransportPrice)

        if (isValidate === true) {
            const newForm = new FormData();

            newForm.append('doc', uploadedFile);

            for (let key in newTransportPrice) {
                newForm.append(key, newTransportPrice[key]);
            }

            transportPriceService.add(newForm)
            setIsModalOpen(false)
        } else {
            setIsFirstValidated(true)
        }
 
    };

     

    const openAdd = () => {
        setValidates({})
        setIsModalOpen(true)
        setIsFirstValidated(false)
        newNewTransportPrice(transportPriceResetData)
    }

    const handleKeyPress = (event) => {
        const keyCode = event.keyCode || event.which;
        const keyValue = String.fromCharCode(keyCode);
        const regex = /^[0-9]+$/; // Regular expression to match only numeric characters

        if (!regex.test(keyValue)) {
            event.preventDefault();
        }
    };

    const stylesError = { 
        control: (provided, state) => ({
            ...provided,
            border: state.isFocused ? '1px solid rgb(225 29 72)' : '1px solid rgb(225 29 72)',
            boxShadow: state.isFocused ? 'none' : 'none',
            '&:hover': {
                border: state.isFocused ? '1px solid rgb(225 29 72)' : '1px solid rgb(225 29 72)', // Apply blue border on hover if focused, otherwise regular border
            },
            minHeight: "35px",
            width: '100%',
            cursor: 'pointer',
            borderRadius: '5px',
        }),    
    };
  


    return (
        <div>

            <span onClick={() => openAdd()} className={cl.AddBtn}>
                <span className={cl.icon}><Upload /></span>
                  {t('UploudPrices')}
            </span>

            <Modal size="small" isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>

                <div className={cl.modalHead} >
                    <h3> <span className={cl.iconHead}><Upload /></span>{t('UploudPrices')} </h3>
                </div>
    

                <fieldset className={cl.formField}>
                    <legend>{t('ReceivingPort')}</legend>

                    <MultiSelect
                        parentOptions={appState.countries}
                        childOptions={appState.cities}
                        parentId={newTransportPrice.reciever_country_id}
                        childId={newTransportPrice.reciever_city_id}
                        isNetwork={true}
                        styles={selectStyle}
                        onChange={async (reciever_country_id, reciever_city_id) => {
                            newNewTransportPrice(prevState => ({
                                ...prevState,
                                reciever_country_id: reciever_country_id ? reciever_country_id : 0,
                                reciever_city_id: reciever_city_id ? reciever_city_id : 0,
                            }))
                        }}
                        join={"country_id"}
                        placeholder={t('Country')}
                        placeholderSub={t('Port')}
                        validate={validates && validates.reciever_country_id ? true : false}
                        validateSub={validates && validates.reciever_city_id ? true : false}
                    />


                </fieldset>

                <fieldset className={cl.formField} style={{ display: 'flex' , gap: '10px' }}>
                    <div style={{ width: "50%" }}>
                        <Select
                            styles={validates && validates.website_id ? { ...selectStyle, ...stylesError } : selectStyle}
                            options={websites}
                            value={websites.find(option => option.value === newTransportPrice.website_id)}
                            onChange={(selectedOption) => {
                                newNewTransportPrice(prevState => ({
                                    ...prevState,
                                    website_id: selectedOption ? selectedOption.value : 0,
                                }));
                            }}
                            placeholder={t('Website')}
                        />


                    </div>

                    <div style={{ width: "50%" }}>
                        <Select
                            styles={validates && validates.location_country_id ? { ...selectStyle, ...stylesError } : selectStyle}
                            options={countries}
                            value={countries.find(option => option.value === newTransportPrice.location_country_id)}
                            onChange={(selectedOption) => {
                                newNewTransportPrice(prevState => ({
                                    ...prevState,
                                    location_country_id: selectedOption ? selectedOption.value : 0,
                                }));
                            }}
                            placeholder={t('Location')}
                        />

                    </div>
                </fieldset>
 
             
            <div style={{ width: '100%' }}>
                <legend>Excel</legend>

                <div className={cl.uploadDiv}>
                    <input type="file"   onChange={handleFileChange} />
                </div>

            </div>

                <span onClick={saveHandle} className={cl.btnPrimary}>{t('UploudPrices')}</span>


                    <div style={{ marginTop: '20px' }}> 
                        <a href={us_example} download>
                            {t('ExampleUSA')}
                        </a>
                    </div>

                    <div> 

                        <a href={kr_example} download>
                            {t('ExampleKorea')}
                        </a>
                    </div>

                    <div> 

                        <a href={other_example} download>
                            {t('ExampleOTHER')}
                        </a>
                    </div>

                    <div style={{ marginTop: '20px', color: '#d80228', fontStyle: 'italic' }}> 
                        {t('FirstLine')}
                    </div>
            </Modal>
        </div>
    );
};

export default AddTransportPriceModal;